import {Inject, injectable} from 'inversify-props';

import {FileChange} from '@/model/system/storage/FileChange';

import {IApiService} from '@/services/IApi.service';
import {ISystemStorageService} from '@/services/system/ISystemStorage.service';

@injectable()
export class SystemStorageService implements ISystemStorageService {

  @Inject(Symbol.for('IApiService'))
  private apiService!: IApiService;

  private path: string = '/system/storage';

  public async getUserChanges(): Promise<FileChange[]> {
    return await this.apiService.get(`${this.path}/changes/user`);
  }

  public async getUserConfigChanges(): Promise<FileChange[]> {
    return await this.apiService.get(`${this.path}/changes/user/config`);
  }
}
